const icons = {
  "bars-3": require("./bars-3.svg"),
  "x-mark": require("./x-mark.svg"),
  "check": require("./check.svg"),
  "double-tick": require("./double-tick.svg"),
  "plus": require("./plus.svg"),
  "minus": require("./minus.svg"),
  "magnifying-glass": require("./magnifying-glass.svg"),
  "magnifying-glass-focus": require("./magnifying-glass-focus.svg"),
  "magnifying-glass-plus": require("./magnifying-glass-plus.svg"),
  "magnifying-glass-minus": require("./magnifying-glass-minus.svg"),
  "home": require("./home.svg"),
  "cog-6-tooth": require("./cog-6-tooth.svg"),
  "trash": require("./trash.svg"),
  "arrow-left": require("./arrow-left.svg"),
  "arrow-right": require("./arrow-right.svg"),
  "arrow-up": require("./arrow-up.svg"),
  "arrow-down": require("./arrow-down.svg"),
  "arrow-long-left": require("./arrow-long-left.svg"),
  "arrow-long-right": require("./arrow-long-right.svg"),
  "arrow-long-up": require("./arrow-long-up.svg"),
  "arrow-long-down": require("./arrow-long-down.svg"),
  "arrow-path": require("./arrow-path.svg"),
  "arrow-rotate-cw": require("./arrow-rotate-cw.svg"),
  "arrow-rotate-ccw": require("./arrow-rotate-ccw.svg"),
  "arrow-top-right-on-square": require("./arrow-top-right-on-square.svg"),
  "arrow-right-on-rectangle": require("./arrow-right-on-rectangle.svg"),
  "arrow-left-on-rectangle": require("./arrow-left-on-rectangle.svg"),
  "chevron-left": require("./chevron-left.svg"),
  "chevron-right": require("./chevron-right.svg"),
  "chevron-up": require("./chevron-up.svg"),
  "chevron-down": require("./chevron-down.svg"),
  "chevron-double-left": require("./chevron-double-left.svg"),
  "chevron-double-right": require("./chevron-double-right.svg"),
  "envelope": require("./envelope.svg"),
  "envelope-open": require("./envelope-open.svg"),
  "chat-bubble-left": require("./chat-bubble-left.svg"),
  "chat-bubble-right": require("./chat-bubble-right.svg"),
  "chat-bubble-left-ellipsis": require("./chat-bubble-left-ellipsis.svg"),
  "chat-bubble-right-ellipsis": require("./chat-bubble-right-ellipsis.svg"),
  "chat-bubble-left-right": require("./chat-bubble-left-right.svg"),
  "phone": require("./phone.svg"),
  "phone-x-mark": require("./phone-x-mark.svg"),
  "user": require("./user.svg"),
  "user-circle": require("./user-circle.svg"),
  "user-plus": require("./user-plus.svg"),
  "user-minus": require("./user-minus.svg"),
  "user-group": require("./user-group.svg"),
  "users": require("./users.svg"),
  "alert": require("./alert.svg"),
  "play": require("./play.svg"),
  "pause": require("./pause.svg"),
  "stop": require("./stop.svg"),
  "play-circle": require("./play-circle.svg"),
  "pause-circle": require("./pause-circle.svg"),
  "speaker-wave": require("./speaker-wave.svg"),
  "speaker-x-mark": require("./speaker-x-mark.svg"),
  "microphone": require("./microphone.svg"),
  "microphone-mute": require("./microphone-mute.svg"),
  "video-camera": require("./video-camera.svg"),
  "camera": require("./camera.svg"),
  "photo": require("./photo.svg"),
  "panorama": require("./panorama.svg"),
  "musical-note": require("./musical-note.svg"),
  "code": require("./code.svg"),
  "console": require("./console.svg"),
  "horizontal-3-dots": require("./horizontal-3-dots.svg"),
  "vertical-3-dots": require("./vertical-3-dots.svg"),
  "save": require("./save.svg"),
  "computer-laptop": require("./computer-laptop.svg"),
  "computer-code": require("./computer-code.svg"),
  "computer-desktop": require("./computer-desktop.svg"),
  "device-phone-mobile": require("./device-phone-mobile.svg"),
  "device-tablet": require("./device-tablet.svg"),
  "battery-0": require("./battery-0.svg"),
  "battery-10": require("./battery-10.svg"),
  "battery-50": require("./battery-50.svg"),
  "battery-100": require("./battery-100.svg"),
  "controller": require("./controller.svg"),
  "game": require("./game.svg"),
  "window": require("./window.svg"),
  "shopping-cart": require("./shopping-cart.svg"),
  "shopping-bag": require("./shopping-bag.svg"),
  "basket": require("./basket.svg"),
  "credit-card": require("./credit-card.svg"),
  "banknotes": require("./banknotes.svg"),
  "calendar": require("./calendar.svg"),
  "calendar-plus": require("./calendar-plus.svg"),
  "calendar-minus": require("./calendar-minus.svg"),
  "calendar-approve": require("./calendar-approve.svg"),
  "calendar-reject": require("./calendar-reject.svg"),
  "calendar-days": require("./calendar-days.svg"),
  "briefcase": require("./briefcase.svg"),
  "presentation-chart-line": require("./presentation-chart-line.svg"),
  "presentation-media": require("./presentation-media.svg"),
  "whiteboard": require("./whiteboard.svg"),
  "chart-line": require("./chart-line.svg"),
  "chart-bar": require("./chart-bar.svg"),
  "chart-pie": require("./chart-pie.svg"),
  "currency-dollar": require("./currency-dollar.svg"),
  "currency-euro": require("./currency-euro.svg"),
  "currency-pound": require("./currency-pound.svg"),
  "currency-yen": require("./currency-yen.svg"),
  "currency-ringgit": require("./currency-ringgit.svg"),
  "tabs": require("./tabs.svg"),
  "document": require("./document.svg"),
  "document-text": require("./document-text.svg"),
  "document-duplicate": require("./document-duplicate.svg"),
  "folder": require("./folder.svg"),
  "folder-open": require("./folder-open.svg"),
  "folder-plus": require("./folder-plus.svg"),
  "folder-minus": require("./folder-minus.svg"),
  "clipboard": require("./clipboard.svg"),
  "clipboard-document-check": require("./clipboard-document-check.svg"),
  "paper-clip": require("./paper-clip.svg"),
  "archive-box": require("./archive-box.svg"),
  "inbox": require("./inbox.svg"),
  "book-open": require("./book-open.svg"),
  "book-close": require("./book-close.svg"),
  "book-stacked": require("./book-stacked.svg"),
  "lock-closed": require("./lock-closed.svg"),
  "lock-open": require("./lock-open.svg"),
  "key": require("./key.svg"),
  "shield-check": require("./shield-check.svg"),
  "shield-exclamation": require("./shield-exclamation.svg"),
  "exclamation-circle": require("./exclamation-circle.svg"),
  "exclamation-triangle": require("./exclamation-triangle.svg"),
  "information-circle": require("./information-circle.svg"),
  "question-mark-circle": require("./question-mark-circle.svg"),
  "bell": require("./bell.svg"),
  "bell-alert": require("./bell-alert.svg"),
  "eye": require("./eye.svg"),
  "eye-slash": require("./eye-slash.svg"),
  "light-bulb": require("./light-bulb.svg"),
  "bolt": require("./bolt.svg"),
  "moon": require("./moon.svg"),
  "sun": require("./sun.svg"),
  "cloud": require("./cloud.svg"),
  "thunder": require("./thunder.svg"),
  "star": require("./star.svg"),
  "heart": require("./heart.svg"),
  "hand-thumb-up": require("./hand-thumb-up.svg"),
  "hand-thumb-down": require("./hand-thumb-down.svg"),
  "flag": require("./flag.svg"),
  "bookmark": require("./bookmark.svg"),
  "map": require("./map.svg"),
  "map-pin": require("./map-pin.svg"),
  "globe-alt": require("./globe-alt.svg"),
  "truck": require("./truck.svg"),
  "cake": require("./cake.svg"),
  "gift": require("./gift.svg"),
  "trophy": require("./trophy.svg"),
  "medal": require("./medal.svg"),
  "qr-code": require("./qr-code.svg"),
  "wifi": require("./wifi.svg"),
  "vr": require("./vr.svg"),
  "ar": require("./ar.svg"),
  "group-object": require("./group-object.svg"),
  "ungroup-object": require("./ungroup-object.svg"),
  "align-left-object": require("./align-left-object.svg"),
  "align-center-object": require("./align-center-object.svg"),
  "align-right-object": require("./align-right-object.svg"),
  "align-top-object": require("./align-top-object.svg"),
  "align-middle-object": require("./align-middle-object.svg"),
  "align-bottom-object": require("./align-bottom-object.svg"),
  "carousel": require("./carousel.svg"),
  "reel": require("./reel.svg"),
  "grid": require("./grid.svg"),
  "tic-tac-toe": require("./tic-tac-toe.svg"),
  "robot": require("./robot.svg"),
  "chatbot": require("./chatbot.svg"),
  "arrow-left-arrow-right": require("./arrow-left-arrow-right.svg"),
  "arrow-up-arrow-down": require("./arrow-up-arrow-down.svg"),
  "arrow-left-right": require("./arrow-left-right.svg"),
  "arrow-up-down": require("./arrow-up-down.svg"),
  "arrow-up-down-left-right": require("./arrow-up-down-left-right.svg"),
  "maximize": require("./maximize.svg"),
  "minimize": require("./minimize.svg"),
  "layout": require("./layout.svg"),
  "focus": require("./focus.svg"),
  "hourglass-0": require("./hourglass-0.svg"),
  "hourglass-50": require("./hourglass-50.svg"),
  "hourglass-80": require("./hourglass-80.svg"),
  "hourglass-100": require("./hourglass-100.svg"),
  "clock": require("./clock.svg"),
  "time-reset": require("./time-reset.svg"),
  "layer-stacks": require("./layer-stacks.svg"),
  "cube": require("./cube.svg"),
  "sphere": require("./sphere.svg"),
  "cylinder": require("./cylinder.svg"),
  "tube": require("./tube.svg"),
  "cone": require("./cone.svg"),
  "pyramid": require("./pyramid.svg"),
  "polygon": require("./polygon.svg"),
  "torus": require("./torus.svg"),
  "plane": require("./plane.svg"),
  "wedge": require("./wedge.svg"),
  "roof": require("./roof.svg"),
  "cylinder-half": require("./cylinder-half.svg"),
  "sphere-half": require("./sphere-half.svg"),
  "heart-extruded": require("./heart-extruded.svg"),
  "torus-knot": require("./torus-knot.svg"),
  "tetrahedron": require("./tetrahedron.svg"),
  "octahedron": require("./octahedron.svg"),
  "icosahedron": require("./icosahedron.svg"),
  "dodecahedron": require("./dodecahedron.svg"),
  "sparkles": require("./sparkles.svg"),
  "magic-wand": require("./magic-wand.svg"),
  "contrast": require("./contrast.svg"),
  "cursor": require("./cursor.svg"),
  "square": require("./square.svg"),
  "rectangle": require("./rectangle.svg"),
  "circle": require("./circle.svg"),
  "diamond": require("./diamond.svg"),
  "hexagon": require("./hexagon.svg"),
  "draw-line": require("./draw-line.svg"),
  "draw-curve": require("./draw-curve.svg"),
  "pencil": require("./pencil.svg"),
  "eraser": require("./eraser.svg"),
  "scissor": require("./scissor.svg"),
  "font": require("./font.svg"),
  "text": require("./text.svg"),
  "text-align-center": require("./text-align-center.svg"),
  "text-align-left": require("./text-align-left.svg"),
  "text-align-right": require("./text-align-right.svg"),
  "text-align-justify": require("./text-align-justify.svg"),
  "sliders-horizontal": require("./sliders-horizontal.svg"),
  "sliders-vertical": require("./sliders-vertical.svg")
};

export default icons;
